import React from "react";
import { Link } from "@inertiajs/react";
import { cn } from "../../utils/cn";
import {
  baseClasses,
  colorClasses,
  hoverColorClasses,
  hoverShadow,
  LinkType,
} from "./buttonStyles";

interface InertiaLinkProps {
  text: string;
  disabled?: boolean;
  color?: "peach";
  type?: LinkType;
  className?: string;
  href: string;
}

const InertiaLink: React.FC<InertiaLinkProps> = ({
  text,
  disabled = false,
  color = "peach",
  type = "primary",
  className,
  href,
}) => {
  const classes = cn(
    baseClasses,
    colorClasses[color][type],
    className,
    disabled
      ? "cursor-default opacity-50"
      : cn("hover:cursor-pointer", hoverShadow, hoverColorClasses[color][type]),
  );

  const handleClick = (e: React.MouseEvent<Element, MouseEvent>) => {
    if (disabled) {
      e.preventDefault();
    }
  };

  return (
    <Link className={classes} href={href} onClick={handleClick}>
      {text}
    </Link>
  );
};

export default InertiaLink;
